import * as React from 'react';

// TYPES
interface DisplayPhoneNumberTypes {
	children?: string;
}

export const DisplayPhoneNumber: React.FC<DisplayPhoneNumberTypes> = ({ children }) => {
	const formatPhoneNumber = (phoneNumber?: string) => {
		if (phoneNumber) {
			const numberArray = phoneNumber.toString().split('');

			if (numberArray[0] === '1' && numberArray.length === 10) {
				// 1800 160 401  or  1300 975 707
				numberArray.splice(4, 0, ' ');

				numberArray.splice(8, 0, ' ');
			} else if (numberArray[0] === '1' && numberArray.length === 6) {
				//  13 00 00
				numberArray.splice(2, 0, ' ');

				numberArray.splice(5, 0, ' ');
			} else if (numberArray[0] === '0' && numberArray[1] === '4' && numberArray.length === 10) {
				//  0491 570 159
				numberArray.splice(4, 0, ' ');

				numberArray.splice(8, 0, ' ');
			} else if (numberArray[0] === '0' && numberArray.length === 10) {
				//  02 5550 4321
				numberArray.splice(2, 0, ' ');

				numberArray.splice(7, 0, ' ');
			} else {
				//  Fallback Do nothing
			}

			return numberArray.join('');
		}
	};
	return <>{formatPhoneNumber(children)}</>;
};

export default DisplayPhoneNumber;
